export default "__VITE_ASSET__B7_FX7nS__"